import React, { Component } from 'react';
import {
  AverageTemperature,
  AverageTemperatureTitle,
  ChartContainer,
  ContentContainer,
  DateText,
  Details,
  DetailsContainer,
  FirstContent,
  Item,
  LastRegistration,
  LoadingContainer,
  SecondContent,
  SerialText,
  Title,
  VolumeListContainer,
  Wrapper,
} from './styles';
import { Line, LineChart } from 'recharts';
import LoadingIndicator from '../../../../../../components/LoadingIndicator';
import { format } from 'date-fns';
import EmptyState from '../../../../../../components/EmptyState';
import { RemoveRedEyeOutlined } from '@mui/icons-material';

class VolumeList extends Component {
  constructor(props) {
    super(props);
  }

  _formatDate(text) {
    const date = new Date(text);
    return format(date, "dd/MM/yyyy 'às' HH:mm");
  }

  render() {
    const { temperatureVolumeListData, getVolumeDetailsBySerial, isLoading } =
      this.props;

    if (isLoading) {
      return (
        <LoadingContainer>
          <Title>Lista de volumes</Title>
          <Wrapper>
            <LoadingIndicator theme="dark" text="Carregando..." />
          </Wrapper>
        </LoadingContainer>
      );
    }

    if (temperatureVolumeListData.length > 0 && !isLoading) {
      return (
        <VolumeListContainer>
          <Title>Lista de volumes</Title>
          {temperatureVolumeListData.map(value => {
            const formattedTemperatureList = value.temperature.map(item => ({
              value: item
            }));

            return (
              <Item key={value.serial}>
                <ContentContainer>
                  <FirstContent>
                    <SerialText>{value.serial}</SerialText>
                    <div>
                      <LastRegistration>Último registro:</LastRegistration>
                      <DateText>
                        {this._formatDate(value.lastRegistrationDate)}
                      </DateText>
                    </div>
                  </FirstContent>
                  <SecondContent>
                    <AverageTemperatureTitle>
                      Temperatura média
                    </AverageTemperatureTitle>
                    <ChartContainer>
                      <LineChart width={135} height={20} data={formattedTemperatureList}>
                        <Line
                          dataKey="value"
                          stroke="#263465"
                          strokeWidth={1.5}
                          dot={false}
                        />
                      </LineChart>
                      <AverageTemperature>
                        {value.averageTemperature}&#8451;
                      </AverageTemperature>
                    </ChartContainer>
                  </SecondContent>
                </ContentContainer>
                <DetailsContainer
                  onClick={() => getVolumeDetailsBySerial(value.serial)}
                >
                  <Details>
                    <RemoveRedEyeOutlined />
                    Detalhes
                  </Details>
                </DetailsContainer>
              </Item>
            )
          })}
        </VolumeListContainer>
      );
    }

    return (
      <VolumeListContainer>
        <Title>Lista de volumes</Title>
        <EmptyState message="Nenhum volume encontrado." fullWidth />
      </VolumeListContainer>
    );
  }
}

export default VolumeList;
